import toast from 'react-hot-toast'
import { getRandomName, toCamelCase } from '../config/settings'
export const AGGREFATE_FUNCTIONS = [
  {
    name: `AVG`,
    description: `Averages the set of numbers in the specified measure, grouped by the chosen dimension or dimensions.`,
    syntax: `avg(params)`,
    functionString: "avg(${0:params})",
    functionName: "avg",
    returnType:'number'
  },
  {
    name: `COUNT`,
    description: `Calculates the number of values in a dimension or measure, grouped by the chosen dimension or dimensions.`,
    syntax: `count(params)`,
    functionString: "count(${0:params})",
    functionName: "count",
    returnType:'number'
  },
  {
    name: `MAX`,
    description: `Returns the maximum value of the specified measure or date, grouped by the chosen dimension or dimensions.`,
    syntax: `max(params)`,
    functionString: "max(${0:params})",
    functionName: "max",
    returnType:'number'
  },
  {
    name: `MIN`,
    description: `Returns the minimum value of the specified measure or date, grouped by the chosen dimension or dimensions.`,
    syntax: `min(params)`,
    functionString: "min(${0:params})",
    functionName: "min",
    returnType:'number'
  },
  {
    name: `SUM`,
    description: `Adds the set of numbers in the specified measure, grouped by the chosen dimension or dimensions.`,
    syntax: `sum(params)`,
    functionString: "sum(${0:params})",
    functionName: "sum",
    returnType:'number'
  },
  {
    name: `CONCAT`,
    description: `Concatenates two or more strings.`,
    syntax: `concat(param1, param2,...)`,
    functionString: "concat(${0:params})",
    functionName: "concat",
    returnType:'string'
  },
  {
    name: `COUNTDISTINCT`,
    description: `Calculates distinct count of the operand `,
    syntax: `countDistinct(params)`,
    functionString: "countDistinct(${0:params})",
    functionName: "countDistinct",
    returnType:'number'
  },
  {
    name: `DISTINCTCOUNT`,
    description: `Calculates distinct count of the operand `,
    syntax: `distinctCount(params)`,
    functionString: "distinctCount(${0:params})",
    functionName: "distinctCount",
    returnType:'number'
  },
  {
    name: `COUNTOVER`,
    description: `Calculates count of the operand partitioned by specified attributes.`,
    syntax: `countOver(params,[])`,
    functionString: "countOver(${0:params},[])",
    functionName: "countOver",
    returnType:'number'
  },
  {
    name: `DISTINCTCOUNTOVER`,
    description: `Calculates distinct count of the operand partitioned by specified attributes.`,
    syntax: `distinctCountOver(params,[])`,
    functionString: "distinctCountOver(${0:params},[])",
    functionName: "distinctCountOver",
    returnType:'number'
  },
  {
    name: `SUMOVER`,
    description: `Calculates sum of the measure partitioned by specified attributes.`,
    syntax: `sumOver(params,[])`,
    functionString: "sumOver(${0:params},[])",
    functionName: "sumOver",
    returnType:'number'
  },
  {
    name: `COUNTIF`,
    description: `Calculates the number of values in a dimension or measure, grouped by the chosen dimension or dimensions.`,
    syntax: `countIf(params, if)`,
    functionString: "countIf(${0:params}, if)",
    functionName: "countIf",
    returnType:'number'
  },
  {
    name: `DISTINCTCOUNTIF`,
    description: `Calculates the number of distinct values in a dimension or measure, grouped by the chosen dimension or dimensions.`,
    syntax: `distinctCountIf(params, if)`,
    functionString: "distinctCountIf(${0:params}, if)",
    functionName: "distinctCountIf",
    returnType:'number'
  },
  {
    name: `SUMIF`,
    description: `Adds the set of numbers in the specified measure, grouped by the chosen dimension or dimensions.`,
    syntax: `sumIf(params, if)`,
    functionString: "sumIf(${0:params},if)",
    functionName: "sumIf",
    returnType:'number'
  },

  {
    name: 'AVGOVER',
    description: `Calculates avg of the measure partitioned by specified attributes.`,
    syntax: `avgOver(measure, [])`,
    functionString: "avgOver(${0:measure},[])",
    functionName: "avgOver",
    returnType:'number'
  },
  {
    name: 'MINOVER',
    description: `Calculates min of the measure partitioned by specified attributes.`,
    syntax: `minOver(params,[])`,
    functionString: "minOver(${0:params},[])",
    functionName: "minOver",
    returnType:'number'
  },
  {
    name: 'MAXOVER',
    description: `Calculates max of the measure partitioned by specified attributes.`,
    syntax: `maxOver(params,[])`,
    functionString: "maxOver(${0:params},[])",
    functionName: "maxOver",
    returnType:'number'
  },
  {
    name: 'IFELSE',
    description: `Evaluates a set of if, then expression pairings, and returns the value of the then argument for the first if argument that evaluates to true. Returns else if no if evaluates to true.`,
    syntax: `ifelse(if, then [, if, then ...], else)`,
    functionString: "ifelse(${0})",
    functionName: "ifelse",
    returnType:'dynamic'
  },
  {
    name: "ROUND",
    description: "Rounds a decimal value to the closest integer if no scale is specified, or to the closest decimal place if scale is specified.",
    syntax: `round(decimal, scale)`,
    functionString: "round(${0})",
    functionName: "round",
    returnType:'number'
  },
  {
    name: "FLOOR",
    description: "Rounds a decimal (decimal) value down to the closest, lowest integer.",
    syntax: `floor(decimal)`,
    functionString: "floor(${0})",
    functionName: "floor",
    returnType:'number'
  },
  {
    name: "CEIL",
    description: "Rounds a decimal (decimal) value up to the next highest integer.",
    syntax: `ceil(decimal)`,
    functionString: "ceil(${0})",
    functionName: "ceil",
    returnType:'number'
  },
  {
    name: "FORMATDATE",
    description: "Formats a date using a specified format (format).",
    syntax: `formatDate(date, format)`,
    functionString: "formatDate(${0},'%Y-%m-%d')",
    functionName: "formatDate",
    returnType:'string'
  },
  {
    name: "SUBSTR",
    description: "Returns a substring of the supplied STRING or BYTES value.",
    syntax: `SUBSTR(field, position[, length])`,
    functionString: "SUBSTR(${0},2)",
    functionName: "SUBSTR",
    returnType:'string'
  },
  {
    name: "GROUP_CONCAT",
    description: "Used to concatenate data from multiple rows into one field.",
    syntax: `GROUP_CONCAT(field, delimeter,[orderby_attribute_ASC_or_DESC])`,
    functionString: "GROUP_CONCAT(${0},', ')",
    functionName: "GROUP_CONCAT",
    returnType:'string'
  },
  {
    name: "DATE",
    description: "Converts string to date",
    syntax: `DATE(string)`,
    functionString: "DATE(${0})",
    functionName: "DATE",
    returnType:'time'
  },
  {
    name: "date_diff",
    description: "Returns the date difference between two dates in one of units.('day','year','week','month','minute','second','hour','quarter','millisecond')",
    syntax: `date_diff(unit,date1,date2)`,
    functionString: "date_diff('day',${0:params},)",
    functionName: "date_diff",
    returnType:'number'
  },
  {
    name: "denseRank",
    description: "Calculates dense rank based on the sort attributes partitioned by specified attributes.",
    syntax: `denseRank([partitionBy_Attributes],[orderby_attribute_ASC_or_DESC])`,
    functionString: "denseRank([${0:array_of_partition_by_attributes}],[${0:array_of_order_by_field__ASC_or_DESC}])",
    functionName: "denseRank",
    returnType:'number'
  },
  {
    name: "rowNumber",
    description: "Calculates row number based on the sort attributes partitioned by specified attributes.",
    syntax: `rowNumber([partitionBy_Attributes],[orderby_attribute_ASC_or_DESC])`,
    functionString: "rowNumber([${0:array_of_partition_by_attributes}],[${0:array_of_order_by_field__ASC_or_DESC}])",
    functionName: "rowNumber",
    returnType:'number'
  },
  {
    name: "fromUnixtime",
    description: "This function helps to return date /DateTime representation of a Unix timestamp. The format of returning value will be ‘YYYY-MM-DD HH:MM:SS’ or ‘YYYYMMDDHHMMSS’, depending on the context of the function.",
    syntax: `fromUnixtime(dimension)`,
    functionString: "fromUnixtime(${0:params})",
    functionName: "fromUnixtime",
    returnType:'time'
  }
]

const ERROR_CONSTANTS = {
  syntax_error: 'Invalid Function Expression',
  column_error: 'Invalid Function Parameters',
  conditional_error: 'Function should contain conditional expression',
  fn_error: "Aggregate function cannot have another aggregate functions in it",
  mismatch_type: "Function return type must be same for if and else",
  sort_order_error: 'Provide sort order for every orderby field in array'
}

export const calculatedFieldRegex = new RegExp(/\b(AND|OR|<>|!=|>=|<=|>|<|=|UPPER|IN|LOWER|IS|NOT|NULLIF|NULL|CAST|DISTINCT|AS|DOUBLE|DECIMAL|FLOAT64|VARCHAR|INTEGER|DESC|ASC|NOW\(\)|BETWEEN|CURRENT_DATE)\b|(?<!-)[+\/*(),\[\]]|-(?!-)/g);
export const additiveRegex = new RegExp(/AND|OR|<>|!=|>=|\$|{|}|<=|>|<|=|-|\+|\,|\*|\/|\(|\)|UPPER|IN|LOWER|IS|NOTNULLIF|NULL|CAST|DISTINCT|AS|DOUBLE|DECIMAL|FLOAT64|DESC|ASC|desc|asc|VARCHAR|INTEGER|NOW\(\)|BETWEEN|CURRENT_DATE/)
// const paramRegex = new RegExp(/,(?=(?:(?:[^']*'|'){2})*[^']*$)/)
//export const paramRegex = new RegExp(/(?:\[.*?\]|[^,\s]+)/,'g')
export const paramRegex = new RegExp(/(?:\b(\w+)\b\s*(\b(\w+)\b)?(?:=|<>|>|<|>=|<=|!=)?\s*(?:'[^']*'|\S+)?|(?:\[.*?\]|'[^']*'|[^,\s]+(?:\s*(?:=|<>|>|<|>=|<=|!=)\s*'[^']*')?))(?:\s*(?:AND|OR)\s*(?:\b(\w+)\b\s*(?:=|<>|>|<|>=|<=|!=)\s*(?:'[^']*'|\S+)?|(?:\[.*?\]|'[^']*'|[^,\s]+(?:\s*(?:=|<>|>|<|>=|<=|!=)\s*'[^']*')?)))*(?=\s*,|\s*$)/,'g')
//export const paramRegex = new RegExp(/(\b\w+\b\s+\w+\b|\[.*?\]|'[^\']*'|[^,\s]+(?:\s*(?:=|<>|>|<|>=|<=|!=)\s*'[^']*')?)/,'g')
const fnNames = AGGREFATE_FUNCTIONS.map(fn => fn.functionName);
const fnRegex = new RegExp(`\\b${fnNames.join('\\b|\\b')}\\b`, 'g')
const fnNamesCaps = AGGREFATE_FUNCTIONS.map(fn => fn.functionName.toUpperCase());
export const universalRegex = new RegExp(`(${fnNames.join('.*?\\()|(')})|(${fnNamesCaps.join('.*?\\()|(')})|(COALESCE)|(from_unixtime)|(STRING_AGG)|(SEPARATOR)|(format_date)|(date_format)|(DATEDIFF)|(TIMESTAMP_MILLIS)|(TIMESTAMP)|(ELSE)|(CASE)|(WHEN)|(THEN)|(END)|(ROW_NUMBER)|(ORDER BY)|(ASC)|(asc)|(DESC)|(desc)|('.*?')|(IN.*?\\))|(CONCAT)|(AND)|(OR)|(OVER)|(PARTITION BY)|<>|!=|>=|<=|>|<|=|-|\\+|\\,|\\*|\\/|\\(|\\)|(DENSE_RANK)|(UPPER.*?\\()|(LOWER.*?\\()|(IS)|(NULLIF)|(NOT)|(NULL)|(CAST.*?\\()|(DISTINCT)|(AS)|(DOUBLE)|(DECIMAL)|(FLOAT64)|(VARCHAR)|(INTEGER)|(NOW.*?\\))|(Asia/Kolkata)|(BETWEEN)|(CURRENT_DATE)|(CURRENT_TIMESTAMP)|(day)|(month)|(year)|(week)|(quarter)|(hour)|(minute)|(second)|(millisecond)`,'g')
const asDoubleRegex = new RegExp(/asdouble/, 'gi')
const asFloatRegex = new RegExp(/asfloat64/, 'gi')

export async function functionEval(str, displayName, dataset, measures, editFlag) {  
  let name = toCamelCase(displayName.split(' ').join('_'),false)
  let validName = measures.filter(obj => obj.name.toLowerCase() == name.toLowerCase() && obj._id != editFlag)
  if (validName.length > 0) {
    toast.error('Field with this name already exists')
    return false
  }
  let fnMatch = str.match(fnRegex)
  if (fnMatch && fnMatch.length > 0) {
    let { paranthesis, counts } = getParanthesisCount(str);
    if (counts['('] != counts[')']) {
      toast.error(ERROR_CONSTANTS.syntax_error)
      return false
    }
    try{
      let obj = generateCustomField(str, fnMatch.reverse(), fnRegex, dataset, measures)
      //console.log(obj)
      let fnName = fnMatch[0]
      let measure = {
        ...obj,
        displayName,
        dataSetId: dataset._id,
        dataSetName: dataset.dataSetName,
        name
      }
      if (editFlag) {
        let dim = measures.find(obj => obj._id == editFlag)
        if(dim){
          measure['_id'] = editFlag
          measure['name'] = dim.name.split('.').length > 1 ?  dim.name.split('.')[1] : dim.name
        }       
      }
      //console.log(measure)
      //return false
      return measure
    }catch(err){
      console.log(err)
      toast.error(err.message)
      return false
    }    
    //console.log(paranthesis,counts)
  }else{
    try{
      let [sql,dataSetType] = getCalculatedSqlField(str, measures,dataset)
      let measure = {
        type:'number',
        dataSetType,
        calculatedField:str,
        sql,
        displayName,
        dataSetId: dataset._id,
        name
      }
      if (editFlag) {
        let dim = measures.find(obj => obj._id == editFlag)
        if(dim){
          measure['_id'] = editFlag
          measure['name'] = dim.name.split('.').length > 1 ?  dim.name.split('.')[1] : dim.name
        }       
      }
      //console.log(measure)
      //return false
      return measure
    }catch(err){
      console.log(err)
      toast.error(err.message)
      return false
    }
    
  }
}

function generateCustomField(str, fnMatch, fnRegex, dataset, measures) {
  //console.log(fnMatch)
  let originalSql = str
  str = str.replaceAll('NOW()','CURRENT_DATE')
  let fnObj = {}
  for(let fn of fnMatch){
    //console.log(fn,str)    
    let regex = new RegExp(`\\b${fn}\\b`, 'g')
    let spltStr = str.split(regex)
    if (!spltStr || spltStr.length < 2) {
      continue
    }

    let newStr = spltStr[1];
    let { paranthesis, counts } = getParanthesisCount(spltStr[1]);
    if (counts['('] < counts[')']) {
      newStr = newStr.substring(spltStr[1].indexOf('('), spltStr[1].lastIndexOf(')'))
    }

    ({paranthesis, counts} = getParanthesisCount(newStr))
    //console.log('Para',newStr,paranthesis,counts)
    let comparePara = { '(': 0, ')': 0 }
    if(paranthesis){
      for (let eachPara of paranthesis) {
        comparePara[eachPara]++
        if (comparePara['('] === comparePara[')']) {
          break
        }
      }
    }

    let endPara = getPosition(newStr, ')', comparePara[')'])
    newStr = newStr.substring(spltStr[1].indexOf('(') + 1, endPara)
    //console.log(newStr)
    let params
    if(['ifelse','date_diff','formatDate','concat'].indexOf(fn) > -1){
      params = newStr.match(/(?:[^,']+|'[^']*')+/g).filter(n => n)
    }else if(['sumIf','countIf','distinctCountIf'].indexOf(fn) > -1){
      params = newStr.match(/(?:[^,]+)/g).map(match => match.trim())
    }else if(['round','floor','ceil'].indexOf(fn) > -1){
      params = splitTopLevelParams(newStr)
    }else{
      params = newStr.match(paramRegex).filter(n => n)
    }
    
    //console.log("STR:-",newStr,"##Params##",params)
    let fnStr = `${fn}(params,dataset,measures)`
    let fnOrgiStr = `${fn}(${newStr})`
    //console.log(fnStr,fnOrgiStr)
    let dim = eval(fnStr)
    //console.log(dim)
    if(dim){
      let name = getRandomName(10)
      fnObj[name] = dim
      measures.push({name:name,sql:name,tempField:true,type:dim.type,dataSetType:dim.dataSetType})
      str = str.replaceAll(fnOrgiStr,name)
    }    
  }
  let dataSetType
  [str,dataSetType] = getCalculatedSqlField(str,measures,dataset)
  //console.log(str)
  let keyArr = Object.keys(fnObj)
  let name = keyArr[keyArr.length - 1]
  //console.log(str,fnObj,name)
  let type = 'number'
  let sql = ''

  if(fnObj[name]){
    type = fnObj[name].type
    dataSetType = fnObj[name].dataSetType
    sql = fnObj[name].sql
  }
  //console.log(fnObj)
  let fields = str.trim().replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  //console.log(fields)
  if(fields.length == 1 && keyArr.length > 1){
    str = sql
    str = getFinalSqlStr(fnObj,measures,str)
  }else{
    str = getFinalSqlStr(fnObj,measures,str)
  }
  
  //console.log(str,fnObj)
  //throw Error('Invalid')
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    str = str.replaceAll('CURRENT_DATE','CURRENT_TIMESTAMP')
  }else{
    str = str.replaceAll('CURRENT_DATE','NOW()')
  }

  return {sql:str,calculatedField:originalSql,type,dataSetType}
}

const getFinalSqlStr = (fnObj,measures,str) => {  
  let fields = str.trim().replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n)) && !fnRegex.test(n)).filter(String)
  //console.log(str,universalRegex)
  for(let field of fields){
    let fieldName = field.replace(/\${(.*?)\}/gi, "$1")
    let measure = measures.find(obj => obj.name == fieldName)
    //console.log(measure)
    if(measure){
      if(measure?.tempField){
        str = str.replaceAll(field,getFinalSqlStr(fnObj,measures,fnObj[fieldName].sql))
      }else{
        const reg = new RegExp(`\\b${field}\\b`, 'g')
        str = str.replaceAll(reg, '${' + field + '}')
      }
    }else{
      throw Error(`${ERROR_CONSTANTS.column_error} (${field})`)
    }
  }
  return str
}

function splitTopLevelParams(str) {
  const result = [];
  let current = '';
  let depth = 0;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === '(') {
      depth++;
      current += char;
    } else if (char === ')') {
      depth--;
      current += char;
    } else if (char === ',' && depth === 0) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  if (current.trim()) {
    result.push(current.trim());
  }

  return result;
}


const validateMeasureParams = (measures, str) => { 
  return measures.some((el) => el.name === str)
}

const getSqlField = (measures, name) => {
  let measure = measures.find(obj => obj.name == name)
  //console.log(measures,name)
  if(measure){
    //console.log(measure)
    if(measure.tempField){
      return name
    }else{
      return '${' + name + '}';
    }
  }else{
    throw new Error(ERROR_CONSTANTS.syntax_error)
  }
  
}

const getCubeSqlField = (measures, name) => {
  for (let measure of measures) {
    if (measure.name == name) {
      return measure.sql
    }
  }
}

const getConditionalSqlField = (measures, str) => {
  //console.log(str)
  const operators = ['<>','!=', '<=', '>=', '<', '>', '=']

  if (str.startsWith('[') && str.endsWith(']')) {
    str = str.slice(0, 0)
    str = str.slice(0, -1)
  }

  let filterArr = [];
  let splitArr = str.trim().replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  splitArr = [...new Set(splitArr)]
  for (let field of splitArr) {
    const reg = new RegExp(`\\b${field}\\b`, 'g')
    str = str.replaceAll(reg, '${' + field + '}')
    //str = str.replaceAll(field,'${'+field+'}')  
  }
  filterArr.push({ sql: `${str}` })
  //console.log('Filter',str,filterArr)
  return filterArr;
}

const getCalculatedSqlField = (str, measures,dataset) => {
  str = convertDevisorToCast(str,dataset)
  let strSplit = str.trim().replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  //console.log(strSplit);
  let type = "DIMENSION"
  for (let field of strSplit) {
    if (!validateMeasureParams(measures, field)) {
      throw Error(ERROR_CONSTANTS.column_error)
    }
    let name = getSqlField(measures,field)
    let measure = measures.find(obj => obj.name == field)
    if(measure.dataSetType == 'MEASURE'){
      type = 'MEASURE'
    }
    const reg = new RegExp(`\\b${field}\\b`, 'g')
    str = str.replaceAll(reg, name)
    //str = str.replaceAll(field,'${'+field+'}')    
  }
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    str = str.replaceAll(asFloatRegex, ' AS FLOAT64')
  }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
    str = str.replaceAll(asDoubleRegex, ' AS DECIMAL')
  }else{
    str = str.replaceAll(asDoubleRegex, ' AS DOUBLE')
  }  
  return [str,type];
}

const checkMeasureConditionsParams = (measures, str, OVER = false) => {
  const operators = ['<=', '>=', '=','!=', '<>', '<', '>', '/']
  //const conditions = ['AND', 'OR']
  let isOperator = false
  //console.log(measures,str,'Condition')
  if (str.startsWith('[') && str.endsWith(']')) {
    str = str.slice(0, 0)
    str = str.slice(0, -1)
  }
  if(str.includes('==')){
    throw Error(ERROR_CONSTANTS.column_error)
  }
  for (let operator of operators) {
    if (str.includes(operator) || str.includes('IS NULL') || str.includes('IS NOT NULL') || str.includes('IN')) {
      isOperator = true
      //let arr = str.trim().match(/('.*?')|(\bIN\b\(.*?\))|AND|OR|<>|!=|>=|<=|>|<|=|-|\+|\,|\*|\/|\(|\)|UPPER|LOWER|IS|NULLIF|NOT|NULL|CAST|DISTINCT|AS|DOUBLE|DECIMAL|FLOAT64|VARCHAR|INTEGER|NOW\(\)|BETWEEN|CURRENT_DATE/g)
      let operatorsSplit = str.trim().replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
      //let splitArr = operatorsSplit.filter(n => isNaN(parseFloat(n)))
      //splitArr = splitArr.filter(n => !(/['||"]/.test(n)))
      console.log('splitArr',str,operatorsSplit)
      for (let str of operatorsSplit) {
        if (!validateMeasureParams(measures, str)) {
          throw Error(ERROR_CONSTANTS.column_error)
        }
      }
    }
  }
  if (!isOperator && !OVER) {
    throw Error(ERROR_CONSTANTS.conditional_error)
  }
  return true
}

function extractDivisorOld(expr) {
  // First, strip the outermost parentheses if present
  if (expr.startsWith('(') && expr.endsWith(')')) {
    expr = expr.slice(1, -1);
  }

  let depth = 0;
  for (let i = 0; i < expr.length; i++) {
    const char = expr[i];
    if (char === '(') depth++;
    if (char === ')') depth--;

    // Look for division operator at top level
    if (char === '/' && depth === 0) {
      let start = i + 1;
      while (expr[start] === ' ') start++; // Skip whitespace

      if (expr[start] === '(') {
        // Now we extract from this open parenthesis
        let parenDepth = 1;
        let end = start + 1;
        while (end < expr.length && parenDepth > 0) {
          if (expr[end] === '(') parenDepth++;
          if (expr[end] === ')') parenDepth--;
          end++;
        }

        if (parenDepth === 0) {
          return expr.slice(start, end); // includes the outer ()
        }
      }
    }
  }

  return null;
}

function extractDivisor_v1(expr) {
  let slashIndex = expr.indexOf('/');
  if (slashIndex === -1) return null;

  // Start after the slash
  let i = slashIndex + 1;

  // Skip whitespace
  while (i < expr.length && expr[i] === ' ') i++;

  // Case 1: Parenthesized divisor
  if (expr[i] === '(') {
    let start = i;
    let depth = 1;
    i++;
    while (i < expr.length && depth > 0) {
      if (expr[i] === '(') depth++;
      if (expr[i] === ')') depth--;
      i++;
    }
    if (depth === 0) {
      return expr.slice(start, i); // include outer parentheses
    } else {
      return null; // Unbalanced parentheses
    }
  }

  // Case 2: Non-parenthesized — go until operator or end
  let start = i;
  while (
    i < expr.length &&
    !['+', '-', '*', '/', ')', ' '].includes(expr[i])
  ) {
    i++;
  }

  return expr.slice(start, i).trim();
}

function extractDivisor(expression) {
  const slashIndex = expression.indexOf('/');
  if (slashIndex === -1) return null;

  let i = slashIndex + 1;

  // Skip whitespace
  while (i < expression.length && expression[i] === ' ') i++;

  // Case 1: Parenthesized divisor
  if (expression[i] === '(') {
    let start = i;
    let depth = 1;
    i++;
    while (i < expression.length && depth > 0) {
      if (expression[i] === '(') depth++;
      if (expression[i] === ')') depth--;
      i++;
    }
    if (depth === 0) return expression.slice(start, i);
    return null; // unbalanced
  }

  // Case 2: Non-parenthesized — read until operator, closing paren, or space
  const start = i;
  while (
    i < expression.length &&
    !['+', '-', '*', '/', ')'].includes(expression[i])
  ) {
    i++;
  }

  return expression.slice(start, i).trim();
}


const convertDevisorToCast = (str,dataset) => {
  let divisor = extractDivisor(str)
  console.log(str,divisor)
  if(divisor){
    let divisorStr = divisor
    if(isNaN(parseFloat(divisor))){
      if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
        divisorStr = typeof divisor == 'number' ? divisor:divisor.replace(divisor, `(CAST(NULLIF(${divisor},0) AS FLOAT64))`)
      }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
        divisorStr = typeof divisor == 'number' ? divisor:divisor.replace(divisor, `(CAST(NULLIF(${divisor},0) AS DECIMAL))`)
      }else{
        divisorStr = typeof divisor == 'number' ? divisor:divisor.replace(divisor, `(CAST(NULLIF(${divisor},0) AS DOUBLE))`)
      } 
    } 
    str = str.replace(divisor,divisorStr)
  }  
  /* let splitArr = str.split('/')
  if (splitArr.length > 1) {
    for (let i = 1; i < splitArr.length; i++) {
      if (splitArr[i][0] == '(') {
        let result = splitArr[i].match(/\((.*?)\)/);
        console.log(result)
        if(isNaN(parseFloat(result[0]))){
          if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
            splitArr[i] = typeof result[0] == 'number' ? result[0]:splitArr[i].replace(result[0], `(CAST(NULLIF(${result[0]},0) AS FLOAT64))`)
          }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
            splitArr[i] = typeof result[0] == 'number' ? result[0]:splitArr[i].replace(result[0], `(CAST(NULLIF(${result[0]},0) AS DECIMAL))`)
          }else{
            splitArr[i] = typeof result[0] == 'number' ? result[0]:splitArr[i].replace(result[0], `(CAST(NULLIF(${result[0]},0) AS DOUBLE))`)
          } 
        }               
      } else {
        let word = splitArr[i].split(/%|-|\+|\*|\/|\)|,/)[0]
        if(isNaN(parseFloat(word))){
          if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
            splitArr[i] = typeof word == 'number' ? word:splitArr[i].replace(word, `(CAST(NULLIF(${word},0) AS FLOAT64))`)
          }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
            splitArr[i] = typeof word == 'number' ? word:splitArr[i].replace(word, `(CAST(NULLIF(${word},0) AS DECIMAL))`)
          }else{
            splitArr[i] = typeof word == 'number' ? word:splitArr[i].replace(word, `(CAST(NULLIF(${word},0) AS DOUBLE))`)
          }
        }       
      }
    }
    str = splitArr.join('/')
  } */
  return str
}

function getParanthesisCount(str) {
  let paranthesis = str.match(/\(|\)/g)
  const counts = {}
  if(paranthesis){
    for (const type of paranthesis) {
      counts[type] = counts[type] ? counts[type] + 1 : 1;
    }
  }    
  return { counts: counts, paranthesis: paranthesis };
}

function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}

export const rowNumber = (args, dataset, measures) => {
  let partitionFieldsStr = args[0]
  let orderFieldsStr = args[1]
  let partitionFields = args.filter(n => n != orderFieldsStr)
  partitionFields[0] = partitionFields[0].replace('[', '')
  partitionFields[partitionFields.length - 1] = partitionFields[partitionFields.length - 1].replace(']', '')
  let measureArr = measures.filter(obj => partitionFields.indexOf(obj.name) >= 0 && obj.dataSetType == 'DIMENSION')
  //console.log(measureArr,partitionFields,args)
  if (!measureArr || measureArr.length != partitionFields.length) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let orderFields = args.filter(n => n != partitionFieldsStr)
  orderFields[0] = orderFields[0].replace('[', '')
  orderFields[orderFields.length - 1] = orderFields[orderFields.length - 1].replace(']', '')
  let allowedFnArr = ['DESC', 'ASC', 'desc', 'asc']
  const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
  let fnMatch = orderFieldsStr.match(fnRegex)
  if (!fnMatch || fnMatch.length != orderFields.length) {
    throw Error(ERROR_CONSTANTS.sort_order_error)
  }
  let regexExp = new RegExp(/DESC|#|ASC|desc|asc/)
  let actualOrderFields = orderFields.join('#').split(regexExp).map(n => n.trim()).filter(String)
  if (!actualOrderFields) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let fieldsArr = measures.filter(obj => actualOrderFields.indexOf(obj.name) >= 0)
  if (!fieldsArr || fieldsArr.length != actualOrderFields.length) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }

  let sql = `ROW_NUMBER() OVER (PARTITION BY ${partitionFields.join(',')} ORDER BY ${orderFields.join(',')})`
  let calculatedField = `rowNumber([${partitionFields.join(',')}],[${orderFields.join(',')}])`
  for (let field of [...new Set([...partitionFields, ...actualOrderFields])]) {
    const reg = new RegExp(`\\b${field}\\b`, 'g')
    sql = sql.replaceAll(reg, getSqlField(measures, field))
  }
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const count = (args, dataset, measure) => {
  //console.log('Count',args)
  let dim = args[0].trim()
  if (!validateMeasureParams(measure, dim)) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `COUNT(${getSqlField(measure, dim)})`
  let calculatedField = `count(${dim})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const avg = (args, dataset, measure) => {
  //console.log(args)
  let dim = args[0].trim()
  if (!validateMeasureParams(measure, dim)) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `AVG(${getSqlField(measure, dim)})`
  let calculatedField = `avg(${dim})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const max = (args, dataset, measures) => {
  let field = args[0].trim()
  if (!validateMeasureParams(measures, field)) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `MAX(${getSqlField(measures, field)})`
  let calculatedField = `max(${field})`
  let dim = measures.find(obj => obj.name == field)
  return {sql,calculatedField,type:dim.type,dataSetType:'MEASURE'}
}

export const min = (args, dataset, measures) => {
  let field = args[0].trim()
  if (!validateMeasureParams(measures, field)) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `MIN(${getSqlField(measures, field)})`
  let calculatedField = `min(${field})`
  let dim = measures.find(obj => obj.name == field)
  return {sql,calculatedField,type:dim.type,dataSetType:'MEASURE'}
}

export const sum = (args, dataset, measure) => {
  let dim = args[0].trim()
  //console.log(args)
  if (!validateMeasureParams(measure, dim)) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `SUM(${getSqlField(measure, dim)})`
  let calculatedField = `sum(${dim})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const concat = (args, dataset, measure) => {
  //concat(CAST(userRank AS VARCHAR),'/',CAST(totalRank AS VARCHAR))
  let sqlStr = 'CONCAT(' + args.join(',') + ')'
  let splitArr = args.filter(n => isNaN(parseFloat(n)))
  splitArr = splitArr.filter(n => !(/['||"]/.test(n))).map(n => n.trim())
  splitArr = [...new Set(splitArr)]
  let measureArr = measure.filter(obj => splitArr.indexOf(obj.name) >= 0)
  //console.log(measureArr)
  if (measureArr.length == 0) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }   
  let dataSetType = 'DIMENSION'
  for (let dim of measureArr) {
    let fieldStr = ""
    dataSetType = dataSetType != 'MEASURE' ? dim.dataSetType : dataSetType
    if(dim.type == 'string'){
      fieldStr = `COALESCE(${getSqlField(measure, dim.name)},'')`
    }else{
      fieldStr = getSqlField(measure, dim.name)
    }    
    let name = dim.name
    const reg = new RegExp(`\\b${dim.name}\\b`, 'g')
    sqlStr = sqlStr.replaceAll(reg, fieldStr)
    //sqlStr = sqlStr.replaceAll(name,fieldStr)
  }
  return {sql:sqlStr,calculatedField:`concat(${args.join(',')})`,type:'string',dataSetType}
}

export const DATE = (args, dataset, measure) => {
  let sqlStr = 'DATE(' + args[0] + ')'
  let splitArr = args.filter(n => isNaN(parseFloat(n)))
  splitArr = splitArr.filter(n => !(/['||"]/.test(n))).map(n => n.trim())
  splitArr = [...new Set(splitArr)]
  let measureArr = measure.filter(obj => splitArr.indexOf(obj.name) >= 0)
  if (measureArr.length != splitArr.length) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  if (measureArr.length) {
    for (let dim of measureArr) {
      let fieldStr = getSqlField(measure, dim.name)
      let name = dim.name
      const reg = new RegExp(`\\b${dim.name}\\b`, 'g')
      sqlStr = sqlStr.replaceAll(reg, fieldStr)
    }
  }
  return {sql:sqlStr,calculatedField:`DATE(${args[0]})`,type:'time',dataSetType:'DIMENSION'}
}

export const countDistinct = (args, dataset, measures) => {
  if (!validateMeasureParams(measures, args[0])) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `COUNT(DISTINCT ${getSqlField(measures, args[0])})`
  let calculatedField = `countDistinct(${args[0]})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const distinctCount = (args, dataset, measures) => {
  if (!validateMeasureParams(measures, args[0])) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let sql = `COUNT(DISTINCT ${getSqlField(measures, args[0])})`
  let calculatedField = `distinctCount(${args[0]})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const countIf = (args, dataset, measures) => {
  //console.log(args)
  if (!validateMeasureParams(measures, args[0])) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  if (!checkMeasureConditionsParams(measures, args[1])) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  //console.log(args)
  let condStr = getConditionalSqlField(measures, args[1].trim()).map(obj => obj.sql)
  //console.log(condStr)
  let sql = `COUNT(CASE WHEN ${condStr.join(' AND ')} THEN ${getSqlField(measures, args[0])} ELSE NULL END)`
  let calculatedField = `countIf(${args[0]},${args[1]})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const distinctCountIf = (args, dataset, measures) => {
  if (!validateMeasureParams(measures, args[0])) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  if (!checkMeasureConditionsParams(measures, args[1])) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let condStr = getConditionalSqlField(measures, args[1].trim()).map(obj => obj.sql)
  let sql = `COUNT(DISTINCT (CASE WHEN ${condStr.join(' AND ')} THEN ${getSqlField(measures, args[0])} ELSE NULL END))`
  let calculatedField = `distinctCountIf(${args[0]},${args[1]})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const sumIf = (args, dataset, measures) => {
  console.log(args)
  if (!validateMeasureParams(measures, args[0])) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  if (!checkMeasureConditionsParams(measures, args[1])) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let condStr = getConditionalSqlField(measures, args[1].trim()).map(obj => obj.sql)
  console.log(condStr)
  let sql = `SUM(CASE WHEN ${condStr.join(' AND ')} THEN ${getSqlField(measures, args[0])} ELSE 0 END)`
  let calculatedField = `sumIf(${args[0]},${args[1]})`
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const round = (args, dataset, measures) => {
  //console.log(args)
  if (args.length > 2) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let dataSetType = 'DIMENSION'
  args[0] = convertDevisorToCast(args[0],dataset)
  let sql = args.length > 1 ? `round(${args[0]},${args[1]})` : `round(${args[0]})`
  let calculatedField = args.length > 1 ? `round(${args[0]},${args[1]})` : `round(${args[0]})`
  let measureArr = args[0].replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  //console.log(measureArr)
  if (measureArr && measureArr.length) {
    let matchedArr = measures.filter(obj => measureArr.indexOf(obj.name) > -1)
    if (matchedArr.length != measureArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    for (let field of matchedArr) {
      console.log(field)
      if(field.dataSetType == 'MEASURE'){
        dataSetType = 'MEASURE'
      }
      const reg = new RegExp(`\\b${field.name}\\b`, 'g')
      sql = sql.replaceAll(reg, getSqlField(measures, field.name))
    }
  }
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = sql.replaceAll(asFloatRegex, ' AS FLOAT64')
  }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
    sql = sql.replaceAll(asDoubleRegex, ' AS DECIMAL')
  }else{
    sql = sql.replaceAll(asDoubleRegex, ' AS DOUBLE')
  }
  return {sql,calculatedField,type:'number',dataSetType}
}

export const floor = (args, dataset, measures) => {
  if (args.length > 1) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let dataSetType = 'DIMENSION'
  args[0] = convertDevisorToCast(args[0],dataset)
  let sql = `floor(${args[0]})`
  let calculatedField = `floor(${args[0]})`
  let measureArr = args[0].replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  if (measureArr && measureArr.length) {
    let matchedArr = measures.filter(obj => measureArr.indexOf(obj.name) > -1)
    if (matchedArr.length != measureArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    for (let field of matchedArr) {
      if(field.dataSetType == 'MEASURE'){
        dataSetType = 'MEASURE'
      }
      const reg = new RegExp(`\\b${field.name}\\b`, 'g')
      sql = sql.replaceAll(reg, getSqlField(measures, field.name))
    }
  }
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = sql.replaceAll(asFloatRegex, ' AS FLOAT64')
  }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
    sql = sql.replaceAll(asDoubleRegex, ' AS DECIMAL')
  }else{
    sql = sql.replaceAll(asDoubleRegex, ' AS DOUBLE')
  }
  return {sql,calculatedField,type:'number',dataSetType}
}

export const ceil = (args, dataset, measures) => {
  if (args.length > 1) {
    throw Error(ERROR_CONSTANTS.column_error)
  }
  let dataSetType = 'DIMENSION'
  args[0] = convertDevisorToCast(args[0],dataset)
  let sql = `ceil(${args[0]})`
  let calculatedField = `ceil(${args[0]})`
  let measureArr = args[0].replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  if (measureArr && measureArr.length) {
    let matchedArr = measures.filter(obj => measureArr.indexOf(obj.name) > -1)
    if (matchedArr.length != measureArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    for (let field of matchedArr) {
      if(field.dataSetType == 'MEASURE'){
        dataSetType = 'MEASURE'
      }
      const reg = new RegExp(`\\b${field.name}\\b`, 'g')
      sql = sql.replaceAll(reg, getSqlField(measures, field.name))
    }
  }
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = sql.replaceAll(asFloatRegex, ' AS FLOAT64')
  }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
    sql = sql.replaceAll(asDoubleRegex, ' AS DECIMAL')
  }else{
    sql = sql.replaceAll(asDoubleRegex, ' AS DOUBLE')
  }
  return {sql,calculatedField,type:'number',dataSetType}
}

export const sumOver = (args, dataset, measure) => {
  let field = args[0];
  let overFields = args.filter(n => n != field)
  if (overFields[0].startsWith('[') && overFields[overFields.length - 1].endsWith(']')) {
    overFields[0] = overFields[0].replace('[', '')
    overFields[overFields.length - 1] = overFields[overFields.length - 1].replace(']', '')
    let paramArr = [field, ...overFields]
    paramArr = [...new Set(paramArr)]
    let measureArr = measure.filter(obj => paramArr.indexOf(obj.name) >= 0)
    if (measureArr.length != paramArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    measureArr = measure.filter(obj => (obj.dataSetType == 'MEASURE' && obj.calculatedField || !obj.sql) && paramArr.indexOf(obj.name) >= 0)
    let allowedFnArr = ['sum', 'count', 'avg', 'max', 'min']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    if (measureArr.length) {
      if (measureArr.length > 1) {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
      let sql = measureArr[0].calculatedField
      let fnMatch = sql.match(fnRegex)
      if (fnMatch && fnMatch.length === 1) {
        field = `${measureArr[0].sql}`;
      } else {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
    } else {
      field = `${getSqlField(measure, field)}`
    }
    let sql = `sum(${field}) OVER ( PARTITION BY \${${overFields.join('},${')}} )`
    return {sql,calculatedField:`sumOver(${field},[${overFields.join(',')}])`,type:'number',dataSetType:'MEASURE'}
  } else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
}

export const countOver = (args, dataset, measure) => {
  const sourceFlag = (dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mongobi')
  let field = args[0];
  let overFields = args.filter(n => n != field)
  if (overFields[0].startsWith('[') && overFields[overFields.length - 1].endsWith(']')) {
    overFields[0] = overFields[0].replace('[', '')
    overFields[overFields.length - 1] = overFields[overFields.length - 1].replace(']', '')
    let paramArr = [field, ...overFields]
    paramArr = [...new Set(paramArr)]
    let measureArr = measure.filter(obj => paramArr.indexOf(obj.name) >= 0)
    if (measureArr.length != paramArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    measureArr = measure.filter(obj => (obj.dataSetType == 'MEASURE' && obj.calculatedField || !obj.sql) && paramArr.indexOf(obj.name) >= 0)
    let allowedFnArr = ['sum', 'count', 'avg', 'max', 'min']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    if (measureArr.length) {
      if (measureArr.length > 1) {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
      let sql = measureArr[0].calculatedField
      let fnMatch = sql.match(fnRegex)
      if (fnMatch && fnMatch.length === 1) {
        field = `${measureArr[0].sql}`;
      } else {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
    } else {
      field = `${getSqlField(measure, field)}`
    }
    let sql = `count(${field}) OVER ( PARTITION BY \${${overFields.join('},${')}} )`
    return {sql,calculatedField:`countOver(${field},[${overFields.join(',')}])`,type:'number',dataSetType:'MEASURE'}
  } else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
}

export const distinctCountOver = (args, dataset, measure) => {
  const sourceFlag = (dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mongobi')
  let field = args[0];
  let overFields = args.filter(n => n != field)
  if (overFields[0].startsWith('[') && overFields[overFields.length - 1].endsWith(']')) {
    overFields[0] = overFields[0].replace('[', '')
    overFields[overFields.length - 1] = overFields[overFields.length - 1].replace(']', '')
    let paramArr = [field, ...overFields]
    paramArr = [...new Set(paramArr)]
    let measureArr = measure.filter(obj => paramArr.indexOf(obj.name) >= 0)
    if (measureArr.length != paramArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    measureArr = measure.filter(obj => (obj.dataSetType == 'MEASURE' || !obj.sql) && paramArr.indexOf(obj.name) >= 0)
    let allowedFnArr = ['sum', 'count', 'avg', 'max', 'min']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    if (measureArr.length) {
      if (measureArr.length > 1) {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
      let sql = measureArr[0].calculatedField
      let fnMatch = sql.match(fnRegex)
      if (fnMatch && fnMatch.length === 1) {
        field = `${measureArr[0].sql}`;
      } else {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
    } else {
      field = `${getSqlField(measure, field)}`
    }
    let sql = `DENSE_RANK() OVER (PARTITION BY ${overFields.join(',')} ORDER BY ${field}) + DENSE_RANK() OVER (PARTITION BY ${overFields.join(',')} ORDER BY ${field} desc) - 1`
    return {sql,calculatedField:`distinctCountOver(${field},[${overFields.join(',')}])`,type:'number',dataSetType:'MEASURE'}
  } else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
}

export const avgOver = (args, dataset, measure) => {
  const sourceFlag = (dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mongobi')
  let field = args[0];
  let overFields = args.filter(n => n != field)
  if (overFields[0].startsWith('[') && overFields[overFields.length - 1].endsWith(']')) {
    overFields[0] = overFields[0].replace('[', '')
    overFields[overFields.length - 1] = overFields[overFields.length - 1].replace(']', '')
    let paramArr = [field, ...overFields]
    paramArr = [...new Set(paramArr)]
    let measureArr = measure.filter(obj => paramArr.indexOf(obj.name) >= 0)
    if (measureArr.length != paramArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    measureArr = measure.filter(obj => (obj.dataSetType == 'MEASURE' && obj.calculatedField || !obj.sql) && paramArr.indexOf(obj.name) >= 0)
    let allowedFnArr = ['sum', 'count', 'avg', 'max', 'min']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    if (measureArr.length) {
      if (measureArr.length > 1) {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
      let sql = measureArr[0].calculatedField
      let fnMatch = sql.match(fnRegex)
      if (fnMatch && fnMatch.length === 1) {
        field = `${measureArr[0].sql}`;
      } else {
        toast.error(ERROR_CONSTANTS.fn_error)
        return
      }
    } else {
      field = `${getSqlField(measure, field)}`
    }
    let sql = `avg(${field}) OVER ( PARTITION BY \${${overFields.join('},${')}} )`
    return {sql,calculatedField:`avgOver(${args[0]},[${overFields.join(',')}])`,type:'number',dataSetType:'MEASURE'}
  } else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
}

export const minOver = (args, dataset, measure) => {
  const sourceFlag = (dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mongobi')
  let field = args[0];
  let overFields = args.filter(n => n != field)
  if (overFields[0].startsWith('[') && overFields[overFields.length - 1].endsWith(']')) {
    overFields[0] = overFields[0].replace('[', '')
    overFields[overFields.length - 1] = overFields[overFields.length - 1].replace(']', '')
    let paramArr = [field, ...overFields]
    paramArr = [...new Set(paramArr)]
    let measureArr = measure.filter(obj => paramArr.indexOf(obj.name) >= 0)
    if (measureArr.length != paramArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    measureArr = measure.filter(obj => (obj.dataSetType == 'MEASURE' && obj.calculatedField || !obj.sql) && paramArr.indexOf(obj.name) >= 0)
    let allowedFnArr = ['sum', 'count', 'avg', 'max', 'min']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    if (measureArr.length) {
      if (measureArr.length > 1) {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
      let sql = measureArr[0].calculatedField
      let fnMatch = sql.match(fnRegex)
      if (fnMatch && fnMatch.length === 1) {
        field = `${measureArr[0].sql}`;
      } else {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
    } else {
      field = `${getSqlField(measure, field)}`
    }
    let sql = `min(${field}) OVER ( PARTITION BY \${${overFields.join('},${')}} )`
    return {sql,calculatedField:`minOver(${args[0]},[${overFields.join(',')}])`,type:'number',dataSetType:'MEASURE'}
  } else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
}

export const maxOver = (args, dataset, measure) => {
  //const sourceFlag = (dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mongobi')
  let field = args[0];
  let overFields = args.filter(n => n != field)
  if (overFields[0].startsWith('[') && overFields[overFields.length - 1].endsWith(']')) {
    overFields[0] = overFields[0].replace('[', '')
    overFields[overFields.length - 1] = overFields[overFields.length - 1].replace(']', '')
    let paramArr = [field, ...overFields]
    paramArr = [...new Set(paramArr)]
    let measureArr = measure.filter(obj => paramArr.indexOf(obj.name) >= 0)
    if (measureArr.length != paramArr.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    measureArr = measure.filter(obj => (obj.dataSetType == 'MEASURE' && obj.calculatedField || !obj.sql) && paramArr.indexOf(obj.name) >= 0)
    let allowedFnArr = ['sum', 'count', 'avg', 'max', 'min']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    if (measureArr.length) {
      if (measureArr.length > 1) {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
      let sql = measureArr[0].calculatedField
      let fnMatch = sql.match(fnRegex)
      if (fnMatch && fnMatch.length === 1) {
        field = `${measureArr[0].sql}`;
      } else {
        throw Error(ERROR_CONSTANTS.fn_error)
      }
    } else {
      field = `${getSqlField(measure, field)}`
    }
    let sql = `max(${field}) OVER ( PARTITION BY \${${overFields.join('},${')}} )`
    return {sql,calculatedField:`maxOver(${args[0]},[${overFields.join(',')}])`,type:'number',dataSetType:'MEASURE'}
  } else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
}

export const ifelse = (args, dataset, measure) => {
  //ifelse(pkgPaymentDetails='Processed' AND pkgPaymentType='FREE USER' AND paidAmount>0 AND Status IN('1','3','4','5','6'),'Paid','Free')
  let actualStr = args.join(',')
  if (actualStr.includes('IN(')) {
    let sub1 = 'IN('
    let sub2 = ')'
    var SP = actualStr.indexOf(sub1) + sub1.length;
    var string1 = actualStr.substr(0, SP);
    var string2 = actualStr.substr(SP);
    var TP = string1.length + string2.indexOf(sub2);
    let str = actualStr.substring(SP, TP);
    let replacedStr = str.replaceAll(',', '#')
    const reg = new RegExp(`\b${str}\b`, 'g')
    let newStr = actualStr.replaceAll(str, replacedStr)
    let newArr = newStr.split(',')
    args = []
    for (let arg of newArr) {
      arg = arg.replaceAll('#', ',')
      args.push(arg)
    }
  }
  let chunkSize = 2
  let chunks = [...Array(Math.ceil(args.length / chunkSize))].map(_ => args.splice(0, chunkSize))
  let dimType = 'string'
  let sql = `CASE `
  let counter = 0
  for (let chunk of chunks) {  
    if(chunk.length > 1){
      let ifDim = chunk[0].replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
      let measureArr = measure.filter(obj => ifDim.indexOf(obj.name) >= 0)
      if (measureArr && measureArr.length > 0) {
        for (let dim of measureArr) {
          const reg = new RegExp(`\\b${dim.name}\\b`, 'g')
          chunk[0] = chunk[0].replaceAll(reg, getSqlField(measure, dim.name))
        }
      } else {
        throw Error(ERROR_CONSTANTS.syntax_error)
      }
      ifDim = chunk[1].replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
      measureArr = measure.filter(obj => ifDim.indexOf(obj.name) >= 0)
      if (measureArr && measureArr.length > 0) {
        for (let dim of measureArr) {
          const reg = new RegExp(`\\b${dim.name}\\b`, 'g')
          chunk[1] = chunk[1].replaceAll(reg, getSqlField(measure, dim.name))
          dimType = dim.type
        }
        sql = `${sql}WHEN ${chunk[0]} THEN ${chunk[1]} `
      } else {
        chunk[1] = eval(chunk[1])
        dimType = typeof chunk[1]
        sql = typeof chunk[1] == 'string' ? `${sql}WHEN ${chunk[0]} THEN '${chunk[1]}' `:`${sql}WHEN ${chunk[0]} THEN ${chunk[1]} `
      }      
    }else{
      let ifDim = chunk[0].replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
      let measureArr = measure.filter(obj => ifDim.indexOf(obj.name) >= 0)
      if (measureArr && measureArr.length > 0) {
        for (let dim of measureArr) {
          const reg = new RegExp(`\\b${dim.name}\\b`, 'g')
          chunk[0] = chunk[0].replaceAll(reg, getSqlField(measure, dim.name))
          if (dimType != dim.type) {
            throw Error(ERROR_CONSTANTS.mismatch_type)
          }
        }
        sql = `${sql}ELSE ${chunk[0]} `
      } else {
        chunk[0] = eval(chunk[0])
        sql = typeof chunk[0] == 'string' ? `${sql}ELSE '${chunk[0]}' `:`${sql}ELSE ${chunk[0]} `
        if (dimType != typeof chunk[0]) {
          throw Error(ERROR_CONSTANTS.mismatch_type)
        }
      }
    }
    counter++
    //console.log(chunk)
  }
  sql = `${sql} END`
  return {sql,calculatedField: `ifelse(${args[0]})`,type:dimType,dataSetType:'DIMENSION'}
}

export const formatDate = (args, dataset, measures) => {
  //console.log(args)
  let field = args[0]
  let format = args[1]
  if (!format.includes('%')) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let sql = ''
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = `format_date(${format},${field})`
  }else{
    sql = `date_format(${field},${format})`
  }  
  let calculatedField = `formatDate(${field},${format})`
  let measureArr = field.replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  if (measureArr && measureArr.length) {
    for (let field of measureArr) {
      const reg = new RegExp(`\\b${field}\\b`, 'g')
      sql = sql.replaceAll(reg, getSqlField(measures, field))
    }
  }
  return {sql,calculatedField,type:'string',dataSetType:'DIMENSION'}
}

export const date_diff = (args, dataset, measures) => {
  //console.log(args)
  let unit = args[0].replace(/["']/g, "").toString()
  const unitArr = ['day', 'year', 'week', 'month', 'minute', 'second', 'hour', 'quarter', 'millisecond']
  if (unitArr.indexOf(unit) < 0) {
    throw Error('Invalid unit provided for date')
  }
  let date1 = args[1].trim()
  let date2 = args[2].trim()
  let dimension1 = measures.find(obj => obj.type == 'time' && obj.name == date1)
  let dimension2 = measures.find(obj => obj.type == 'time' && obj.name == date2)
  if (!dimension1 && ['NOW()','CURRENT_DATE'].indexOf(date1) < 0) {
    throw Error('First Dimension must be of date type')
  }else{
    if(['NOW()','CURRENT_DATE'].indexOf(date1) > -1){
      date1 = 'CURRENT_DATE'
    }else{
      date1 = getSqlField(measures, dimension1.name)
    } 
  }
  if (!dimension2 && ['NOW()','CURRENT_DATE'].indexOf(date2) < 0) {
    throw Error('Second Dimension must be of date type')
  }else{
    if(['NOW()','CURRENT_DATE'].indexOf(date2) > -1){
      date2 = 'CURRENT_DATE'
    }else{
      date2 = getSqlField(measures, dimension2.name)
    }    
  }
  let sql = ''
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = `date_diff(${date1},${date2},${unit})`
    sql = sql.replaceAll('CURRENT_DATE','CURRENT_TIMESTAMP')
  }else if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'mysql'){
    sql = `DATEDIFF(${date1},${date2})`
    sql = sql.replaceAll('CURRENT_DATE','NOW()')
  }else{
    sql = `DATEDIFF(${unit},${date1},${date2})`
    sql = sql.replaceAll('CURRENT_DATE','NOW()')
  }
  let calculatedField = `date_diff('${unit}',${date1},${date2})`
  return {sql,calculatedField,type:'number',dataSetType:'DIMENSION'}
}

export const SUBSTR = (args,dataset,measures) => {
  let field = args[0]
  let otherArgs = args.filter(obj => obj != field)
  let sql = `SUBSTR(${field},${otherArgs.join(',')})`
  let calculatedField = `SUBSTR(${field},${otherArgs.join(',')})`
  let nonNumberArgs = otherArgs.filter(n => isNaN(parseFloat(n)))
  if(nonNumberArgs.length > 0){
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let measureArr = field.replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  if (measureArr && measureArr.length) {
    for (let field of measureArr) {
      const reg = new RegExp(`\\b${field}\\b`, 'g')
      sql = sql.replaceAll(reg, getSqlField(measures, field))
    }
  }else {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  return {sql,calculatedField,type:'string',dataSetType:'DIMENSION'}
}

export const GROUP_CONCAT = (args,dataset,measures) => {
  //console.log(args)
  if(args.length > 3){
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let sql = ''
  let field = args[0]
  let delimeter = args[1]
  let orderFieldsStr = args[2] ?? ''
  let calculatedField = `GROUP_CONCAT(${args.join(',')})`
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = `STRING_AGG(${field}, ${delimeter} ORDER_BY)`
  }else{
    sql = `GROUP_CONCAT ( ${field} ORDER_BY  SEPARATOR${delimeter})`
  }
  let orderFields = args.filter(obj => [field,delimeter].indexOf(obj) < 0) 
  let actualOrderFields = []
  if(orderFields.length > 0){
    orderFields[0] = orderFields[0].replace('[', '')
    orderFields[orderFields.length - 1] = orderFields[orderFields.length - 1].replace(']', '')
    let allowedFnArr = ['DESC', 'ASC', 'desc', 'asc']
    const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
    let fnMatch = orderFieldsStr.match(fnRegex)
    if (!fnMatch || fnMatch.length != orderFields.length) {
      throw Error(ERROR_CONSTANTS.sort_order_error)
    }
    let regexExp = new RegExp(/DESC|#|ASC|desc|asc/)
    actualOrderFields = orderFields.join('#').split(regexExp).map(n => n.trim()).filter(String)
    if (!actualOrderFields) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
    let fieldsArr = measures.filter(obj => actualOrderFields.indexOf(obj.name) >= 0)
    if (!fieldsArr || fieldsArr.length != actualOrderFields.length) {
      throw Error(ERROR_CONSTANTS.syntax_error)
    }
  }
  let measureArr = field.replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
  if (!measureArr || measureArr.length < 0) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }  
  let uniqueArr = [...new Set([measureArr[0], ...actualOrderFields])]
  let orderStr = ``
  if(orderFields.length > 0){
    orderStr = `ORDER BY ${orderFields.join(',')}`
  }  
  sql = sql.replaceAll('ORDER_BY', orderStr)
  for (let field of uniqueArr) {
    const reg = new RegExp(`\\b${field}\\b`, 'g')
    sql = sql.replaceAll(reg, getSqlField(measures, field))
  }
  return {sql,calculatedField,type:'string',dataSetType:'MEASURE'}
}

export const CUMMULITIVE_SUM = (args,dataset,measures) => {

}

export const denseRank = (args, dataset, measures) => {
  let partitionFieldsStr = args[0]
  let orderFieldsStr = args[1]
  let partitionFields = args[0].split(',')
  partitionFields[0] = partitionFields[0].replace('[', '')
  partitionFields[partitionFields.length - 1] = partitionFields[partitionFields.length - 1].replace(']', '')
  let orderFields = args[1].split(',')
  orderFields[0] = orderFields[0].replace('[', '')
  orderFields[orderFields.length - 1] = orderFields[orderFields.length - 1].replace(']', '')
  let measureArr = measures.filter(obj => partitionFields.indexOf(obj.name) >= 0 && obj.dataSetType == 'DIMENSION')
  //console.log(measureArr,partitionFields,measures)
  if (!measureArr || measureArr.length != partitionFields.length) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }  
  let allowedFnArr = ['DESC', 'ASC', 'desc', 'asc']
  const fnRegex = new RegExp(`\\b${allowedFnArr.join('\\b|\\b')}\\b`, 'g')
  let fnMatch = orderFieldsStr.match(fnRegex)
  if (!fnMatch || fnMatch.length != orderFields.length) {
    throw Error(ERROR_CONSTANTS.sort_order_error)
  }
  let regexExp = new RegExp(/DESC|#|ASC|desc|asc/)
  let actualOrderFields = orderFields.join('#').split(regexExp).map(n => n.trim()).filter(String)
  //console.log(actualOrderFields)
  if (!actualOrderFields) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let fieldsArr = measures.filter(obj => actualOrderFields.indexOf(obj.name) >= 0)
  if (!fieldsArr || fieldsArr.length != actualOrderFields.length) {
    throw Error(ERROR_CONSTANTS.syntax_error)
  }

  let sql = `DENSE_RANK() OVER (PARTITION BY ${partitionFields.join(',')} ORDER BY ${orderFields.join(',')})`
  let calculatedField = `denseRank([${partitionFields.join(',')}],[${orderFields.join(',')}])`
  let uniqueArr = [...new Set([...partitionFields, ...actualOrderFields])]
  //console.log(uniqueArr)
  for (let field of uniqueArr) {
    const reg = new RegExp(`\\b${field}\\b`, 'g')
    sql = sql.replaceAll(reg, getSqlField(measures, field))
  }
  return {sql,calculatedField,type:'number',dataSetType:'MEASURE'}
}

export const fromUnixtime = (args,dataset,measures) => {
  if(args.length > 1){
    throw Error(ERROR_CONSTANTS.syntax_error)
  }
  let measureArr = measures.filter(obj => args.indexOf(obj.name) >= 0 && obj.dataSetType == 'DIMENSION')
  if(measureArr[0].type != 'number'){
    throw Error('Please pass numeric dimensions only')
  }
  let sql = ''
  if(dataset.dataSource && dataset.dataSource.dbType && dataset.dataSource.dbType == 'bigQuery'){
    sql = `TIMESTAMP_MILLIS(${getSqlField(measures, args[0])})`
  }else{
    sql = `from_unixtime(${getSqlField(measures, args[0])})`
  }
  
  let calculatedField = `fromUnixtime(${args[0]})`
  return {sql,calculatedField,type:'time',dataSetType:'DIMENSION'}
}